import { Layout, Menu, Select } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Parse from 'parse'
import updateInstallation from '../installation'
import { useIntl } from 'react-intl'
import { logout } from '../store/slice/user'
import { MyLocaleType, setLocale } from '../store/slice/locale'
import WindowLanguage from '../utils/WindowLanguage'
import { useUserReduxParse } from '../hooks/user/useUserReduxParse'

export default function Header() {
  const intl = useIntl()
  const { pathname } = useLocation()
  const selectedKey = pathname.split('/')[1]
  const reduxUser = useUserReduxParse()

  const dispatch = useDispatch()
  const isHome = pathname === '/' || pathname === '/home' ? true : false
  const handleLogout = () => {
    Parse.User.logOut()
      .then(() => {
        console.log('user : ' + Parse.User.current())
        updateInstallation({
          user: Parse.User.current(),
        })
        dispatch(logout())
      })
      .catch((error) => {})
  }
  const handleChangeLangauge = (value: MyLocaleType) => {
    dispatch(setLocale(value))
  }
  return (
    <div style={{ backgroundColor: isHome ? '#130f31' : 'transparent' }}>
      <Layout.Header className="header">
        <Link to="/">
          <img
            className="mojitok-bi"
            src={
              require(isHome
                ? '../img/header_logo_white.svg'
                : '../img/header_logo_black.svg').default
            }
            alt=""
          />
        </Link>
        <Menu // theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['home']}
          selectedKeys={[selectedKey]}
          className={isHome ? 'menu menu-black' : 'menu'}
        >
          <Menu.Item key="upload">
            <Link to="/upload/create-package">Upload</Link>
          </Menu.Item>
          <Menu.Item key="mypage">
            <Link to="/mypage">My page</Link>
          </Menu.Item>
          <Menu.Item key="guide">
            <Link to="/guide">Guide</Link>
          </Menu.Item>
          <Menu.Item key="report">
            <Link to="/report">Report</Link>
          </Menu.Item>
          {!reduxUser ? (
            <Menu.Item key="login" className="session-item">
              <Link to="/login">Login</Link>
            </Menu.Item>
          ) : (
            <Menu.Item key="/logout">
              <Link onClick={handleLogout} to="/">
                Logout
              </Link>
            </Menu.Item>
          )}
        </Menu>
        <Select
          className={
            isHome ? 'select-language select-language-black' : 'select-language'
          }
          onChange={handleChangeLangauge}
          value={intl.locale as MyLocaleType}
          defaultValue={WindowLanguage()}
        >
          <Select.Option value="ko">Korean</Select.Option>
          <Select.Option value="en">English</Select.Option>
        </Select>
      </Layout.Header>
    </div>
  )
}
